import { render, staticRenderFns } from "./WalletAuthLogin.vue?vue&type=template&id=49d6c136"
import script from "./WalletAuthLogin.vue?vue&type=script&lang=js"
export * from "./WalletAuthLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports